export const ROUTE_SLIDE_UP_MENU = 'ROUTE_SLIDE_UP_MENU';
export const ROUTE_NEW_MARKER_SELECT_ENTITY_TYPE =
  'ROUTE_NEW_MARKER_SELECT_ENTITY_TYPE';
export const ROUTE_NEW_MARKER_SET_LOCATION = 'ROUTE_NEW_MARKER_SET_LOCATION';
export const ROUTE_NEW_MARKER_COMMENT = 'ROUTE_NEW_MARKER_COMMENT';
export const ROUTE_NEW_MARKER = 'ROUTE_NEW_MARKER';
export const ROUTE_NEW_STORY_MARKER = 'ROUTE_NEW_STORY_MARKER';
export const ROUTE_STORY_MARKER_EDIT = 'ROUTE_STORY_MARKER_EDIT';
export const ROUTE_MARKER_SUMMARY = 'ROUTE_MARKER_SUMMARY';
export const ROUTE_MARKER_SUMMARY_DETAILS = 'ROUTE_MARKER_SUMMARY_DETAILS';
export const ROUTE_MARKER_FLAG = 'ROUTE_MARKER_FLAG';
export const ROUTE_MARKER_EDIT = 'ROUTE_MARKER_EDIT';
export const ROUTE_MARKER_READ = 'ROUTE_MARKER_READ';
export const ROUTE_MARKER_COMMENT_READ = 'ROUTE_MARKER_COMMENT_READ';

export const ROUTE_MY_TRIPS_DETAILS = 'ROUTE_MY_TRIPS_DETAILS';
export const ROUTE_MY_TRIPS_SUMMARY = 'ROUTE_MY_TRIPS_SUMMARY';
export const ROUTE_MY_TRIPS_EDIT = 'ROUTE_MY_TRIPS_EDIT';
export const ROUTE_TRIP_SAVE = 'ROUTE_TRIP_SAVE';
export const ROUTE_TRIP_RESUME = 'ROUTE_TRIP_RESUME';
export const ROUTE_TRIP_ACTIVE = 'ROUTE_TRIP_ACTIVE';

export const ROUTE_TRIP_LOG_ON = 'ROUTE_TRIP_LOG_ON';
export const ROUTE_TRIP_LOG_ON_CONFIRMED = 'ROUTE_TRIP_LOG_ON_CONFIRMED';
export const ROUTE_TRIP_LOG_OFF_CONFIRMED = 'ROUTE_TRIP_LOG_OFF_CONFIRMED';
export const ROUTE_TRIP_LOG_OFF = 'ROUTE_TRIP_LOG_OFF';
export const ROUTE_TRIP_UPDATE_PLAN = 'ROUTE_TRIP_UPDATE_PLAN';
export const ROUTE_TRIP_CREATE_PLAN = 'ROUTE_TRIP_CREATE_PLAN';

export const ROUTE_FLOAT_PLAN = 'ROUTE_FLOAT_PLAN';
export const ROUTE_FLOAT_PLAN_ACTIVATE = 'ROUTE_FLOAT_PLAN_ACTIVATE';
export const ROUTE_FLOAT_PLAN_END = 'ROUTE_FLOAT_PLAN_END';
export const ROUTE_FLOAT_PLAN_LIST = 'ROUTE_FLOAT_PLAN_LIST';
export const ROUTE_FLOAT_TRIP_VIEW = 'ROUTE_FLOAT_TRIP_VIEW';

export const ROUTE_YOU = 'ROUTE_YOU';

export const ROUTE_WEATHER_LOCATION_SEARCH = 'ROUTE_WEATHER_LOCATION_SEARCH';
export const ROUTE_WEATHER_SETTINGS = 'ROUTE_WEATHER_SETTINGS';
export const ROUTE_TRIP_SETTINGS = 'ROUTE_TRIP_SETTINGS';
export const ROUTE_SETTINGS_GENERAL = 'ROUTE_SETTINGS_GENERAL';
export const ROUTE_WEATHER_SHOW = 'ROUTE_WEATHER_SHOW';
export const ROUTE_WEATHER_FORECAST = 'ROUTE_WEATHER_FORECAST';
export const ROUTE_WEATHER_MOST_RECENT_POSITION =
  'ROUTE_WEATHER_MOST_RECENT_POSITION';
export const ROUTE_HELM_POSITION_OVERRIDE = 'ROUTE_HELM_POSITION_OVERRIDE';
export const ROUTE_HELM = 'ROUTE_HELM';
export const ROUTE_PARTNER_FEATURE = 'ROUTE_PARTNER_FEATURE';
export const ROUTE_SETTINGS_PROFILE = 'ROUTE_SETTINGS_PROFILE';
export const ROUTE_ACCOUNT_SETTINGS = 'ROUTE_ACCOUNT_SETTINGS';
export const ROUTE_ACCOUNT_SETTINGS_INTERESTS =
  'ROUTE_ACCOUNT_SETTINGS_INTERESTS';
export const ROUTE_SETTINGS_COMPLETE_PROFILE =
  'ROUTE_SETTINGS_COMPLETE_PROFILE';
export const ROUTE_SETTINGS_LOCATION = 'ROUTE_SETTINGS_LOCATION';
export const ROUTE_SETTINGS_LOCATION_EDIT = 'ROUTE_SETTINGS_LOCATION_EDIT';
export const ROUTE_SETTINGS_DELETE = 'ROUTE_SETTINGS_DELETE';
export const ROUTE_ACCOUNT_DELETED = 'ROUTE_ACCOUNT_DELETED';
export const ROUTE_SETTINGS_ACCOUNT = 'ROUTE_SETTINGS_ACCOUNT';
export const ROUTE_BOAT_DETAILS_CREATE = 'ROUTE_BOAT_DETAILS_CREATE';
export const ROUTE_BOAT_DETAILS_EDIT = 'ROUTE_BOAT_DETAILS_EDIT';
export const ROUTE_BOAT_DETAILS_VIEW = 'ROUTE_BOAT_DETAILS_VIEW';
export const ROUTE_MY_BOATS = 'ROUTE_MY_BOATS';
export const ROUTE_SETTINGS = 'ROUTE_SETTINGS';
export const ROUTE_MAP_SETTINGS = 'ROUTE_MAP_SETTINGS';
export const ROUTE_REMINDERS = 'ROUTE_REMINDERS';
export const ROUTE_ABOUT_US = 'ROUTE_ABOUT_US';
export const ROUTE_GET_NOTIFIED = 'ROUTE_GET_NOTIFIED';

export const ROUTE_DISTANCE_TOOL = 'ROUTE_DISTANCE_TOOL';

export const ROUTE_CHANGE_EMAIL = 'ROUTE_CHANGE_EMAIL';
export const ROUTE_CHANGE_EMAIL_REAUTH_WAITING =
  'ROUTE_CHANGE_EMAIL_REAUTH_WAITING';
export const ROUTE_CHANGE_EMAIL_FORM = 'ROUTE_CHANGE_EMAIL_FORM';

export const ROUTE_AUTHENTICATION_EMAIL_VALIDATION_OF_CLIENT_TOKEN =
  'ROUTE_AUTHENTICATION_EMAIL_VALIDATION_OF_CLIENT_TOKEN';
export const ROUTE_AUTHENTICATION_EMAIL_CHANGE_REAUTH =
  'ROUTE_AUTHENTICATION_EMAIL_CHANGE_REAUTH';
export const ROUTE_AUTHENTICATION_EMAIL_CHANGE_CONFIRM =
  'ROUTE_AUTHENTICATION_EMAIL_CHANGE_CONFIRM';
export const ROUTE_AUTHENTICATION_UNSUBSCRIBE_EMAIL =
  'ROUTE_AUTHENTICATION_UNSUBSCRIBE_EMAIL';

export const ROUTE_LOGIN = 'ROUTE_LOGIN';

export const ROUTE_SUBSCRIBER = 'ROUTE_SUBSCRIBER';

export const ROUTE_NOTIFICATIONS = 'ROUTE_NOTIFICATIONS';
export const ROUTE_INFORMATION_NOTICE = 'ROUTE_INFORMATION_NOTICE';
export const ROUTE_ALERT_DETAILS = 'ROUTE_ALERT_DETAILS';
export const ROUTE_WEATHER_WARNING_DETAILS = 'ROUTE_WEATHER_WARNING_DETAILS';

export const ROUTE_MESSAGE = 'ROUTE_MESSAGE';
export const ROUTE_MAP = 'ROUTE_MAP';
export const ROUTE_ONBOARDING = 'ROUTE_ONBOARDING';
export const ROUTE_CATCH_ALL = 'ROUTE_CATCH_ALL';

export const ROUTE_INCIDENT_REPORT = 'ROUTE_INCIDENT_REPORT';
export const ROUTE_COURSES = 'ROUTE_COURSES';
export const ROUTE_INSURANCE = 'ROUTE_INSURANCE';

export const ROUTE_LOCATION_SEARCH = 'ROUTE_LOCATION_SEARCH';

export const ROUTE_MY_LOCATION = 'ROUTE_MY_LOCATION';
export const ROUTE_PREPARE = 'ROUTE_PREPARE';
export const ROUTE_VESSELS = 'ROUTE_VESSELS';
export const ROUTE_LOCATION_DISCLOSURE = 'ROUTE_LOCATION_DISCLOSURE';

export const ROUTE_ON_THE_WATER_PROMPT = 'ROUTE_ON_THE_WATER_PROMPT';

export const ROUTE_SIGNAL = 'ROUTE_SIGNAL';
export const ROUTE_SHARING = 'ROUTE_SHARING';

export const ROUTE_REGULATIONS = 'ROUTE_REGULATIONS';

export const ROUTE_DROP_PIN = 'ROUTE_DROP_PIN';

export const ROUTE_MARKETPLACE = 'ROUTE_MARKETPLACE';

export const ROUTE_MARKERS = 'ROUTE_MARKERS';
export const ROUTE_SUPPORT = 'ROUTE_SUPPORT';

export const ROUTE_RAMP_GUIDANCE = 'ROUTE_RAMP_GUIDANCE';
export const ROUTE_PLAN = 'ROUTE_PLAN';
export const ROUTE_MAP_INFORMATION = 'ROUTE_MAP_INFORMATION';
